var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"items":_vm.getOptionsSelect(_vm.question.options),"label":"Seleccione"},on:{"change":function($event){return _vm.$emit('get_answer', { option: _vm.answer, question: _vm.question})}},model:{value:(_vm.answer),callback:function ($$v) {_vm.answer=$$v},expression:"answer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }